import styled from "styled-components";

const Wrap = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;

	img {
		margin-top: -1px;
	}
`;

const AirlineIcon = ({title, img}) => (
	<Wrap>
		<img src={img} alt={title} />
		<em>{title}</em>
	</Wrap>
);

export default AirlineIcon;
